import styled from 'styled-components';

export const StyledResultBackground = styled.div`
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  background: ${({ $background }) => $background};
  opacity: 1;
  z-index: 0;
  overflow: hidden;
  position: absolute;
  left: ${({ theme }) => theme.frameOffset};
  right: ${({ theme }) => theme.frameOffset};
  top: ${({ theme }) => theme.navHeight};
  bottom: ${({ theme }) => theme.frameOffset};
`;
export const BackgroundWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  img: nth-child(1) {
    left: 0%;
    scale: 0.7;
    animation-duration: 8s;
    animation-delay: 0s;
  }
  img: nth-child(2) {
    left: 20%;
    top: -30%;
    scale: 0.8;
    animation-duration: 6s;
    animation-delay: 0s;
  }
  img: nth-child(3) {
    left: 40%;
    top: -15%;
    scale: 0.6;
    animation-duration: 7s;
    animation-delay: 0s;
  }
  img: nth-child(4) {
    left: 60%;
    scale: 0.9;
    top: -20%;
    animation-delay: 0s;
  }
  img: nth-child(5) {
    animation-duration: 7.5s;
    scale: 0.7;
    left: 80%;
    top: -5%;
    animation-delay: 0s;
  }
`;

export const FloatingElement = styled.img`
  object-fit: cover;
  animation: fall 8s linear infinite;
  position: absolute;
  width: 20%;
`;
